export { default } from "./useAdjustFontSizeToFitContent";
export * from "./useAdjustFontSizeToFitContent";
